// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".weSsILsyzSEUIcQXTHSORg\\=\\={height:100vh}.SuIyDyDwOj3ATX3AXvQTcQ\\=\\={display:flex;flex-direction:column;padding:1rem;overflow:auto}", "",{"version":3,"sources":["webpack://./components/PageLayout/styles.module.scss"],"names":[],"mappings":"AAAA,4BACE,YAAA,CAGF,4BACE,YAAA,CACA,qBAAA,CACA,YAAA,CACA,aAAA","sourcesContent":[".pageLayout {\n  height: 100vh;\n}\n\n.pageContent {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  overflow: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageLayout": "weSsILsyzSEUIcQXTHSORg==",
	"pageContent": "SuIyDyDwOj3ATX3AXvQTcQ=="
};
export default ___CSS_LOADER_EXPORT___;
